<div class="container">
    <ion-icon class="close clickable" name="close-circle" (click)="close()"></ion-icon>
    <ng-container *ngIf="!showLoadingSpinner; else loading">
        <ion-icon class="refresh clickable" name="refresh-circle" (click)="refreshMetadata()"></ion-icon>
    </ng-container>
    <ng-template #loading>
        <div class="loading-spinner-selector-wrapper">
            <div class="loading-spinner">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-template>

    <div class="title">
        <span class="sopo-popup-title">CONFIRM</span>
        <span class="sopo-popup-text">Click below to confirm your selection</span>
    </div>

    <div class="nft-data">
        <img [src]="nftAsset.imageUrl" class="nft-picture">
    </div>

    <div class="buttons">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close('confirm')">
            <p>Confirm</p>
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-yellow-button ion-activatable clickable" [ngClass]="{'unfavorite': this.favoriteText === 'UNFAVORITE'}" (click)="setFavorite()">
            <p>{{ favoriteText }}</p>
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>
